import React from 'react';
import type { OftalmologiaData } from '../../hooks/useConsultationForm';
import VisualAcuity from './VisualAcuity';
import Refraction from './Refraction';
import SegmentExam from './SegmentExam';
import IopDiagnosisTreatment from './IopDiagnosisTreatment';
import SectionNumberBadge from '../SectionNumberBadge';

interface OftalmologiaSectionProps {
  oftalmologiaData: OftalmologiaData;
  setOftalmologiaField: (section: keyof OftalmologiaData, field: string, value: any) => void;
  sectionNumber?: string;
}

const ANTERIOR_FIELDS = new Set([
  'conjunctiva', 'cornea', 'anterior_chamber', 'iris', 'pupil', 'lens',
]);

const OftalmologiaSection: React.FC<OftalmologiaSectionProps> = ({ oftalmologiaData, setOftalmologiaField, sectionNumber }) => {
  return (
    <div className="row mb-4" data-section="oftalmologica">
      <div className="col-sm-12">
        <div className="card" style={{ borderColor: '#0d9488' }}>
          <div className="card-header text-white" style={{ backgroundColor: '#0d9488' }}>
            <h4 className="card-title mb-0">
              {sectionNumber && <SectionNumberBadge number={sectionNumber} inverse />}
              <i className="fa fa-eye me-2"></i>
              Evaluación Oftalmológica
            </h4>
          </div>
          <div className="card-body">
            <VisualAcuity
              data={oftalmologiaData.visual_acuity}
              onChange={(field, value) => setOftalmologiaField('visual_acuity', field, value)}
            />

            <Refraction
              data={oftalmologiaData.refraction}
              onChange={(field, value) => setOftalmologiaField('refraction', field, value)}
            />

            <SegmentExam
              anterior={oftalmologiaData.anterior_segment}
              posterior={oftalmologiaData.posterior_segment}
              onAnteriorChange={(field, value) => setOftalmologiaField('anterior_segment', field, value)}
              onPosteriorChange={(field, value) => setOftalmologiaField('posterior_segment', field, value)}
            />

            <IopDiagnosisTreatment
              intraocular_pressure={oftalmologiaData.intraocular_pressure}
              diagnosis_oft={oftalmologiaData.diagnosis_oft}
              treatment_oft={oftalmologiaData.treatment_oft}
              onFieldChange={(section, field, value) =>
                setOftalmologiaField(section as keyof OftalmologiaData, field, value)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OftalmologiaSection;
